import styles from '../ActivityDropDown.module.scss'
import cx from 'classnames'
import PropTypes from 'prop-types'

export default function ActivityCheckbox({
  title,
  value,
  isChecked,
  setChecked,
  changeHandler,
  isError,
}) {
  const onChange = (e) => {
    const { value, checked } = e.target
    if(typeof changeHandler === 'function') {
      changeHandler(checked)
    }
    if(typeof setChecked === 'function') {
      setChecked(title, value, checked)
    }
  }

  return (
    <label className={cx(styles.checkboxWrap, { [styles.error]: isError })}>
      <input
        type='checkbox'
        className={cx(styles.inputCheckbox, { [styles.error]: isError })}
        value={`${value}`}
        onChange={onChange}
        checked={isChecked}
      />
      <span className={cx(styles.checkMark, { [styles.error]: isError })} />
      <p className={cx(styles.title, { [styles.error]: isError })}>{title}</p>
    </label>
  )
}

ActivityCheckbox.propTypes = {
  title: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isChecked: PropTypes.bool,
  setChecked: PropTypes.func,
  changeHandler: PropTypes.func,
  isError: PropTypes.bool,
}
